import { NgModule } from '@angular/core';
import { BookingComponent } from './booking.component';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { FlightInformationComponent } from './flight-information/flight-information.component';
import { HistoryComponent } from './history/history.component';
import { EntryExitComponent } from './entry-exit/entry-exit.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    BookingComponent,
    OrderSummaryComponent,
    FlightInformationComponent,
    HistoryComponent,
    EntryExitComponent,
  ],
  imports: [SharedModule],
  exports: [BookingComponent],
})
export class BookingModule {}
